import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { NgToastService } from 'ng-angular-popup';
import { NgOtpInputComponent } from 'ng-otp-input';
import { Router } from '@angular/router';
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginForm!: FormGroup;
  remainingTime: any;
  otplayout: boolean = false;
  isTimerCompleted!: boolean;
  mylayout: boolean = true;
  loginresponse: any;
  submitted = false;
  token: any;
  userdetails: any;
  isLogin: any;
  baseurl: any;
  resphone: any;
  timer: any;
  isResend: boolean = false;
  isMobile: boolean = false;
  config: any;
  color: string = '#007bff';
  backgroundColor: string = '#f8f9fa';
  cardBackGroundColor: string = '#ffffff';

  // Simple flags to prevent multiple API calls
  isSendingOtp: boolean = false;
  isVerifyingOtp: boolean = false;
  lastVerifiedCode: string = '';

  // Flag to prevent double form submission
  private isSubmitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private toast: NgToastService,
    private router: Router,
    private configService: ConfigService
  ) {
    this.loginForm = this.fb.group({
      phone: ['', [
        Validators.required,
        Validators.pattern(/^[6-9][0-9]{9}$/)
      ]]
    });
  }

  @ViewChild('otpInput') otpInput: NgOtpInputComponent | undefined;

  ngOnInit(): void {
    this.isMobile = this.auth.isMobile();

    this.configService.loadConfig().subscribe({
      next: (config) => {
        this.config = config;
        this.color = config?.atLoginPage?.loginButtonColor || '#007bff';
        this.backgroundColor = config?.atLoginPage?.loginPageBackgroundColor || '#f8f9fa';
        this.cardBackGroundColor = config?.atLoginPage?.loginPageCardColor || '#ffffff';
      },
      error: (error) => {
        console.error('Error loading config:', error);
      }
    });

    this.cleanupLocalStorage();
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }
  onPhoneInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Remove anything that is not a digit
    let value = input.value.replace(/\D/g, '');

    // Maximum 10 digits
    value = value.substring(0, 10);

    input.value = value;

    this.loginForm.get('phone')?.setValue(value, {
      emitEvent: true
    });
  }
  private cleanupLocalStorage(): void {
    if (localStorage.getItem('user-details-goldBharat') === 'undefined') {
      localStorage.removeItem('user-details-goldBharat');
    }
    if (localStorage.getItem('user-token-goldBharatFirst') === 'undefined') {
      localStorage.removeItem('user-token-goldBharatFirst');
    }
  }

  private storeToken(token: string): void {
    const formattedToken = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    localStorage.setItem('user-access', formattedToken);
    localStorage.setItem('user-token-goldBharatFirst', formattedToken);
    this.auth.login(formattedToken);
  }

  private storeUserDetails(userDetails: any): void {
    if (userDetails) {
      const userDetailsString = JSON.stringify(userDetails);
      localStorage.setItem('user-details-goldBharat', userDetailsString);
      localStorage.setItem('userData', userDetailsString);
    }
  }

  backToPage() {
    this.stopTimer();
    window.location.reload();
  }

  // This is for resending OTP
  sendotp() {
    if (this.isSendingOtp || !this.resphone) {
      return;
    }

    this.isSendingOtp = true;

    const otpdata = {
      phone: this.resphone
    };

    this.auth.sendOpt(otpdata).subscribe({
      next: (res: any) => {
        this.isSendingOtp = false;
        this.toast.success({ detail: 'Success!', summary: 'OTP Resent Successfully' });
        this.resetOtpState();
      },
      error: (err) => {
        this.isSendingOtp = false;
        this.toast.error({ detail: 'Oops!', summary: err.error?.msg || 'Failed to resend OTP' });
      }
    });
  }

  private resetOtpState(): void {
    this.stopTimer();

    // FIX: Add null check for otpInput
    if (this.otpInput) {
      this.otpInput.setValue('');
    }

    this.isVerifyingOtp = false;
    this.lastVerifiedCode = '';
    this.startTimer();
    this.otplayout = true;
    this.isTimerCompleted = false;
    this.isResend = false;
  }

  onOtpChange(code: string) {
    code = code.trim();
    const numericCode = code.replace(/\D/g, '');

    // Only verify when code is exactly 6 digits and not already verifying
    if (numericCode.length === 6 && !this.isVerifyingOtp) {
      // Add a small delay to ensure user has finished typing
      setTimeout(() => {
        if (numericCode === code.replace(/\D/g, '')) {
          this.verifyOtp(numericCode);
        }
      }, 300);
    }
  }

  private verifyOtp(numericCode: string): void {
    // Prevent multiple verification attempts
    if (this.isVerifyingOtp || this.lastVerifiedCode === numericCode) {
      return;
    }

    this.isVerifyingOtp = true;
    this.lastVerifiedCode = numericCode;

    const data = {
      phone: this.resphone,
      code: numericCode,
    };

    this.auth.verifyOtp(data).subscribe(
      (res: any) => {
        this.isVerifyingOtp = false;

        // Check if verification was successful
        if (res.success) {
          const token = res.data?.token || res.token;

          if (token) {
            this.storeToken(token);
            this.token = token;
          }

          const userDetails = res.data?.userdetails || res.userdetails || res.data?.userData;
          if (userDetails) {
            this.storeUserDetails(userDetails);
            this.userdetails = userDetails;
          }

          this.toast.success({ detail: 'Success!', summary: 'Login Successfully' });
          this.isMobile = this.auth.isMobile();

          if (this.isMobile) {
            this.router.navigate(['/mobile/mobileview']);
          } else {
            this.router.navigate(['/']);
          }

          this.stopTimer();
        } else {
          // Handle unsuccessful verification
          this.toast.error({
            detail: 'Oops!',
            summary: res.message || 'Invalid OTP'
          });

          // Clear the OTP input for retry - FIX: Add null check
          if (this.otpInput) {
            setTimeout(() => {
              if (this.otpInput) {
                this.otpInput.setValue('');
              }
              this.lastVerifiedCode = '';
            }, 500);
          } else {
            setTimeout(() => {
              this.lastVerifiedCode = '';
            }, 500);
          }
        }
      },
      (error: any) => {
        this.isVerifyingOtp = false;

        // Clear for retry - FIX: Add null check
        setTimeout(() => {
          this.lastVerifiedCode = '';
          if (this.otpInput) {
            this.otpInput.setValue('');
          }
        }, 500);

        this.toast.error({
          detail: 'Oops!',
          summary: error.error?.message || error.error?.msg || 'Invalid OTP'
        });
      }
    );
  }

  startTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }

    const duration = 1 * 60;
    let seconds = duration;

    this.timer = setInterval(() => {
      const minutes = Math.floor(seconds / 60);
      const secondsDisplay = (seconds % 60).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
      });

      this.remainingTime = `${minutes}:${secondsDisplay}`;

      if (seconds <= 0) {
        clearInterval(this.timer);
        this.isResend = true;
        this.mylayout = true;
        this.isVerifyingOtp = false;
        this.lastVerifiedCode = '';
      }

      seconds--;
    }, 1000);
  }

  stopTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.mylayout = true;
  }

  onSubmit() {
    // Prevent double submission
    if (this.loginForm.invalid || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    const phoneValue = this.loginForm.get('phone')!.value;

    this.auth.loginUser(this.loginForm.value).subscribe(
      (res: any) => {
        this.resphone = phoneValue;

        // Check if login was successful
        if (res.success) {
          const token = res.data?.token || res.token;
          if (token) {
            this.storeToken(token);
            this.token = token;
          }

          const userDetails = res.data?.userdetails || res.userdetails || res.data;
          if (userDetails) {
            this.storeUserDetails(userDetails);
            this.userdetails = userDetails;
          }

          // Just show the OTP input screen - OTP is already sent by backend
          this.resetOtpState();

          this.loginresponse = res.data;
          this.submitted = false;
          this.loginForm.reset();
        } else {
          // Login failed
          this.toast.error({
            detail: 'Oops!',
            summary: res.message || 'Login failed'
          });
        }


        setTimeout(() => {
          this.isSubmitting = false;
        }, 2000);
      },
      err => {
        this.isSubmitting = false;
        this.toast.error({
          detail: 'Oops!',
          summary: err.error?.message || err.error?.msg || 'Login failed',
          position: 'topCenter'
        });
      }
    );
  }
}